<template>
  <span :id="model?.system?.id">
    <SmartLinkItemComponent :id="model?.system?.id" :component="!model?.system?.workflow">
      <SmartLinkStandaloneElement :codename="type.elements.title.codename">
        <h3 class="basic-content-block__title">
          {{ model?.elements.title.value }}
        </h3>
      </SmartLinkStandaloneElement>

      <SmartLinkStandaloneElement :codename="type.elements.content_.codename">
        <template v-if="splitCharacterCount != 0">
          <RichText :value="undefined" :portable-text="portableText1" />
          <div :id="`collapse-${model?.system?.id}`" ref="showMore" class="collapse">
            <RichText :value="undefined" :portable-text="portableText2" />
          </div>
        </template>
        <div v-else class="basic-content-block__content">
          <RichText :value="model?.elements.content.value" />
        </div>
      </SmartLinkStandaloneElement>

      <SmartLinkStandaloneElement :codename="type.elements.call_to_action.codename">
        <CallToAction
          v-for="cta in pageStore.getListAs<CallToActionModel>(model?.elements.callToAction.value)"
          :key="cta.system.id"
          :model="cta"
        />
      </SmartLinkStandaloneElement>

      <button
        v-if="splitCharacterCount != 0"
        class="btn btn-light ps-0"
        type="button"
        aria-expanded="false"
        data-bs-toggle="collapse"
        :data-bs-target="`#collapse-${model?.system?.id}`"
        :aria-controls="`collapse-${model?.system?.id}`"
      >
        <template v-if="showMoreCollapsed">
          Show More
          <IconCaretDown />
        </template>
        <template v-else>
          Show Less
          <IconCaretUp />
        </template>
      </button>
    </SmartLinkItemComponent>
  </span>
</template>
<script lang="ts" setup>
import { useEventListener } from '@vueuse/core'
import {
  contentTypes,
  type CallToActionModel,
  type SplitContentBasicContentBlockModel
} from '~/models'

const type = contentTypes.split_content__basic_content_block
const props = defineProps<{ model: SplitContentBasicContentBlockModel }>()
const pageStore = usePageStore()

const splitCharacterCount = props.model?.elements.readMoreCharacterCount.value ?? 0
const { portableText1, portableText2 } = splitPortableText(
  splitCharacterCount,
  props.model?.elements.content.value
)

const showMoreCollapsed = ref<boolean>(true)
const showMore = ref<HTMLElement | null>(null)
const { scrollToElementById } = useSmoothScroll()
const initShowMore = () => {
  if (!showMore.value) return
  useEventListener(showMore.value, 'show.bs.collapse', () => {
    showMoreCollapsed.value = false
  })
  useEventListener(showMore.value, 'hide.bs.collapse', () => {
    showMoreCollapsed.value = true
    scrollToElementById(props.model.system.id, 100, true)
  })
}

onMounted(() => {
  initShowMore()
})
</script>
